import { UserRoles, UserRole, UserRoleData } from "./types";

/**
 * Get the role string from a user role entry (handles both string and object formats)
 */
export const getUserRole = (roleEntry: UserRole | UserRoleData | undefined): UserRole | null => {
  if (!roleEntry) return null;
  if (typeof roleEntry === "string") {
    return roleEntry;
  }
  return roleEntry.role;
};

/**
 * Check if a user can comment (defaults to true if not specified)
 */
export const canUserComment = (roleEntry: UserRole | UserRoleData | undefined): boolean => {
  if (!roleEntry) return true; // Default to allowing comments if no role data
  if (typeof roleEntry === "string") {
    return true; // Old format, default to allowing
  }
  return roleEntry.canComment !== false; // Default to true if not specified
};

/**
 * Get full role data from userRoles object
 */
export const getRoleData = (userRoles: UserRoles, uid: string): UserRoleData | null => {
  const entry = userRoles[uid];
  if (!entry) return null;

  if (typeof entry === "string") {
    // Old format - convert to new format
    return {
      role: entry,
      canComment: true, // Default for old format
    };
  }

  return {
    role: entry.role,
    email: entry.email,
    canComment: entry.canComment !== false, // Default to true
  };
};
